module.exports = __webpack_public_path__ + "img/8D50CB1B-37AB-45DE-9925-B78F7F41C641.c58818d3.svg";